/**
 * Component: Market graph
 * Dependency: Am Charts
 */


var ed = ed || {};

ed.marketGraph = new function () {
    /**
     * Init function
     */
    this.init = function () {
        gridMarketGraphs();

        var durationSelector = $('.market-graph-chart-duration');

        durationSelector.each(function(){
            var parentGraph = $(this).closest('.market-graph');
            var currentDuration;

            if(parentGraph.data('single') == true) {
                currentDuration = parentGraph.data('container')[0].Duration;
            }
            else {
                currentDuration = parentGraph.data('container').Duration;
            }

            $(this).val(currentDuration);

            $(this).on('change', function(){
                var selectedDuration = $(this).val();

                loadGraph(parentGraph, parentGraph.data('chart-id'), selectedDuration);
            });
        });
    };

    var chartData = [];

    /**
     * Toggle search form
     */
    function gridMarketGraphs() {
        var marketGraphCount = 0;
        $('.market-graph').each(function () {
            var duration = $(this).data('container').Duration;
            if(duration == undefined) {
                duration = $(this).data('container')[0].Duration;
            }

            loadGraph(this, marketGraphCount, duration);

            marketGraphCount++;
        });
    }

    function loadGraph(item, marketGraphCount, duration) {
        var url;
        var jsonFromContainer = $(item).data('container');
        jsonFromContainer.Duration = duration;
        var isSingle = $(item).data('single');
        var theme = 'ed' + $(item).data('theme');
        var ballonDateFormat = "MMM DD, YYYY";
        var minPeriode = "DD";
        var durationSelector = $(item).find('.market-graph-chart-duration');

        if ((jsonFromContainer[0] && jsonFromContainer[0].Duration === "Day") || (jsonFromContainer && jsonFromContainer.Duration === "Day")) {
            ballonDateFormat = "JJ:NN, MMM DD, YYYY";
            minPeriode = "mm";
        }

        if (isSingle) {
            var useThisDuration = duration;
            if(useThisDuration == undefined) {
                useThisDuration = jsonFromContainer[0].Duration;
            }

            url = '/umbraco/api/MarketInfoApi/GetSingleMarketInfo?isinCode=' +
                jsonFromContainer[0].GraphList[0] +
                '&duration=' + useThisDuration;
        } else {
            jsonFromContainer.Duration = duration;
            url = '/umbraco/api/MarketInfoApi/GetMultipleMarketInfo?json=[' + encodeURIComponent(JSON.stringify(jsonFromContainer)) + ']&duration=' + duration;
        }

        $.get(url,
            function (data) {
                chartData = data;
            }).done(function () {
                // Assign custom ID
                $(item).attr('data-chart-id', marketGraphCount);


                var marketGraphChartHeaderName = $('.market-graph-chart-header__name', item),
                    marketGraphChartHeaderValueLatest = $('.market-graph-chart-header__value-latest', item),
                    marketGraphChartHeaderValueChange = $('.market-graph-chart-header__value-change', item),
                    marketGraphChartHeaderValueYesterday = $('.market-graph-chart-header__value-yesterday', item),
                    marketGraphChart = $('.market-graph-chart', item),
                    marketGraphId = marketGraphCount,
                    marketGraphData = {};

                // Assign custom ID to accomodate for MarketGraph
                marketGraphChart = marketGraphChart.attr('id', 'market-graph-chart-' + marketGraphId);
                marketGraphChart = marketGraphChart.attr('id');

                // Loop through chartdata to get the correct data

                if (isSingle) {
                    marketGraphData.MarketInfoGraphs = [];
                    marketGraphData.MarketInfoGraphs.push(chartData);
                } else {
                    marketGraphData = chartData[0];
                }

                // if available duration does not contain 'Day', then remove it from select options
                if (marketGraphData.MarketInfoGraphs[0].Durations.indexOf("Day") < 0) {
                    console.log(marketGraphData.MarketInfoGraphs[0].Durations.indexOf("Day"));
                    durationSelector.find('option[value="Day"]').remove();
                }

                // if duration is day and it is not present in available durations
                // then reset it to 'week'
                if (duration == "Day" && marketGraphData.MarketInfoGraphs[0].Durations.indexOf("Day") < 0) {
                    // Slet selectordims
                    loadGraph(item, marketGraphCount, "Week");
                }
                
                marketGraphChartHeaderName.text(marketGraphData.MarketInfoGraphs[0].Name);

                // Set the header for the market graph, as well as the header for the current 
                marketGraphChartHeaderValueLatest.text(marketGraphData.MarketInfoGraphs[0].ValueLatest.toPrecision(5));
                marketGraphChartHeaderValueChange.text(marketGraphData.MarketInfoGraphs[0].ValueChange.toPrecision(3) + '%');
                marketGraphChartHeaderValueYesterday.text(marketGraphData.MarketInfoGraphs[0].ValueYesterday.toPrecision(5));


                // Build the data table below the market graph
                gridMarketGraphTable($(item), marketGraphData.MarketInfoGraphs);

                AmCharts.useUTC = false;
                var chart = AmCharts.makeChart(marketGraphChart, {
                    "type": "serial",
                    "theme": theme,
                    "marginTop": 40,
                    "marginRight": 40,
                    "marginLeft": 60,
                    "autoMarginOffset": 20,
                    "numberFormatter": {
                        "precision": 2,
                        "decimalSeparator": ","
                    },
                    "valueAxes": [{
                        "id": "v1",
                        "axisAlpha": 0,
                        "position": "left",
                        "ignoreAxisWidth": true
                    }],
                    "balloon": {
                        "borderThickness": 1,
                        "shadowAlpha": 0
                    },
                    "graphs": [{
                        "id": "g1",
                        "balloon": {
                            "drop": false, //Boxes indstead of ballo0ns
                            "adjustBorderColor": false,
                            "color": "#ffffff"
                        },
                        "bullet": "round",
                        "bulletBorderAlpha": 1,
                        "bulletColor": "#FFFFFF",
                        "bulletSize": 10,
                        "hideBulletsCount": 50,
                        "lineThickness": 4,
                        "title": "red line",
                        "useLineColorForBulletBorder": true,
                        "valueField": "Value",
                        "balloonText": "<span style='font-size:18px;'>[[value]]</span>"
                    }],
                    "chartCursor": {
                        "pan": true,
                        "cursorAlpha": 1,
                        "limitToGraph": "g1",
                        "valueLineAlpha": 0.2,
                        "categoryBalloonDateFormat": ballonDateFormat
                    },
                    "categoryField": "Time",
                    "categoryAxis": {
                        "axisAlpha": 0,
                        "gridAlpha": 0,
                        "parseDates": true,
                        "minPeriod": minPeriode,
                        "dashLength": 0,
                        "minorGridEnabled": true
                    },
                    "dataProvider": marketGraphData.MarketInfoGraphs[0].DataPoints
                });


                $('.market-graph-data-row', item).on('click', function () {
                    var index = $(this).index();

                    chart.dataProvider = marketGraphData.MarketInfoGraphs[index].DataPoints;
                    chart.validateData();

                    marketGraphChartHeaderName.text(marketGraphData.MarketInfoGraphs[index].Name);
                    marketGraphChartHeaderValueLatest.text(marketGraphData.MarketInfoGraphs[index].ValueLatest.toPrecision(5));
                    marketGraphChartHeaderValueChange.text(marketGraphData.MarketInfoGraphs[index].ValueChange.toPrecision(3) + '%');
                    marketGraphChartHeaderValueYesterday.text(marketGraphData.MarketInfoGraphs[index].ValueYesterday.toPrecision(5));
                });

            });
    }

    function gridMarketGraphTable(marketGraph, marketInfoGraphs) {
        var marketGraphData = $('.market-graph-data', marketGraph);
        marketGraphData.empty();
        
        for (var i = 0; i < marketInfoGraphs.length; i++) {
            var html = '<div class="market-graph-data-row">' +
                    '<div class="market-graph-data-row__name">' + marketInfoGraphs[i].Name + '</div>' +
                    '<div class="market-graph-data-row__value-latest">' + marketInfoGraphs[i].ValueLatest.toPrecision(5) + '</div>' +
                    '<div class="market-graph-data-row__value-change">' + marketInfoGraphs[i].ValueChange.toPrecision(3) + '%</div>' +
                    '<div class="market-graph-data-row__value-yesterday">' + marketInfoGraphs[i].ValueYesterday.toPrecision(5) + '</div>' +
                '</div>';

            marketGraphData.append(html);
        }
    }
};
